export default {
ACHADOS_ANORMAIS_DO_RASTREAMENTO_SCREENING_ANTENATAL_DA_MAE: 6547,
ACHADOS_ANORMAIS_DO_RASTREAMENTO_SCREENING_ANTENATAL_DA_MAE_NAO_ESPECIFICADOS: 6555,
ACHADOS_BIOQUIMICOS_ANORMAIS_DO_RASTREAMENTO_SCREENING_ANTENATAL_DA_MAE: 6549,
ACHADOS_CITOLOGICOS_ANORMAIS_DO_RASTREAMENTO_SCREENING_ANTENATAL_DA_MAE: 6550,
ACHADOS_CROMOSSOMICOS_E_GENETICOS_ANORMAIS_DO_RASTREAMENTO_SCREENING_ANTENATAL_DA_MAE: 6553,
ACHADOS_HEMATOLOGICOS_ANORMAIS_DO_RASTREAMENTO_SCREENING_ANTENATAL_DA_MAE: 6548,
ACHADOS_RADIOLOGICOS_ANORMAIS_DO_RASTREAMENTO_SCREENING_ANTENATAL_DA_MAE: 6552,
ACHADOS_ULTRASSONOGRAFICOS_ANORMAIS_DO_RASTREAMENTO_SCREENING_ANTENATAL_DA_MAE: 6551,
AFECCOES_LIGADAS_A_GRAVIDEZ_NAO_ESPECIFICADAS: 6546,
AMEACA_DE_ABORTO: 6502,
ANEMIA_COMPLICANDO_A_GRAVIDEZ_O_PARTO_E_O_PUERPERIO: 6878,
ASSISTENCIA_PRESTADA_A_MAE_POR_ANORMALIDADE_CONHECIDA_OU_SUSPEITA_DOS_ORGAOS_PELVICOS_MATERNOS: 6598,
ASSISTENCIA_PRESTADA_A_MAE_POR_ANORMALIDADE_E_LESAO_FETAIS_CONHECIDAS_OU_SUSPEITADAS: 6609,
ASSISTENCIA_PRESTADA_A_MAE_POR_MOTIVO_DE_APRESENTACAO_ANORMAL_CONHECIDA_OU_SUSPEITADA_DO_FETO: 6577,
ASSISTENCIA_PRESTADA_A_MAE_POR_OUTROS_PROBLEMAS_FETAIS_CONHECIDOS_OU_SUSPEITADOS: 6620,
ASSISTENCIA_PRESTADA_A_MAE_POR_UMA_DESPROPORCAO_CONHECIDA_OU_SUSPEITA: 6587,
ASSISTENCIA_PRESTADA_A_MAE_POR_ANORMALIDADE_CROMOSSOMICA_SUSPEITADA_DO_FETO: 6611,
ASSISTENCIA_PRESTADA_A_MAE_POR_ANORMALIDADE_DA_VAGINA: 6605,
ASSISTENCIA_PRESTADA_A_MAE_POR_ANORMALIDADE_DA_VULVA_E_DO_PERINEO: 6606,
ASSISTENCIA_PRESTADA_A_MAE_POR_ANORMALIDADE_DE_ORGAOS_PELVICOS_NAO_ESPECIFICADA: 6608,
ASSISTENCIA_PRESTADA_A_MAE_POR_APRESENTACAO_ANORMAL_DO_FETO_NAO_ESPECIFICADA: 6586,
ASSISTENCIA_PRESTADA_A_MAE_POR_APRESENTACAO_COMPOSTA: 6584,
ASSISTENCIA_PRESTADA_A_MAE_POR_APRESENTACAO_DE_FACE_MENTO_E_FRONTE: 6581,
ASSISTENCIA_PRESTADA_A_MAE_POR_APRESENTACAO_PELVICA: 6579,
ASSISTENCIA_PRESTADA_A_MAE_POR_CICATRIZ_UTERINA_DEVIDA_A_UMA_CIRURGIA_ANTERIOR: 6601,
ASSISTENCIA_PRESTADA_A_MAE_POR_CRESCIMENTO_FETAL_EXCESSIVO: 6627,
ASSISTENCIA_PRESTADA_A_MAE_POR_DOENCA_HEREDITARIA_SUSPEITADA_DO_FETO: 6612,
ASSISTENCIA_PRESTADA_A_MAE_POR_FETO_VIAVEL_EM_GRAVIDEZ_ABDOMINAL: 6628,
ASSISTENCIA_PRESTADA_A_MAE_POR_GESTACAO_MULTIPLA_COM_APRESENTACAO_ANORMAL_DE_UM_OU_MAIS_FETOS: 6583,
ASSISTENCIA_PRESTADA_A_MAE_POR_HIDROPSIA_FETAL: 6623,
ASSISTENCIA_PRESTADA_A_MAE_POR_INCOMPETENCIA_CERVICAL: 6602,
ASSISTENCIA_PRESTADA_A_MAE_POR_INSUFICIENCIA_DE_CRESCIMENTO_FETAL: 6626,
ASSISTENCIA_PRESTADA_A_MAE_POR_ISOIMUNIZACAO_RH: 6621,
ASSISTENCIA_PRESTADA_A_MAE_POR_LESAO_SUSPEITADA_CAUSADA_AO_FETO_POR_ALCOOLISMO_MATERNO: 6614,
ASSISTENCIA_PRESTADA_A_MAE_POR_LESAO_FETAL_SUSPEITADA_CAUSADA_POR_DOENCA_VIRAL_MATERNA: 6613,
ASSISTENCIA_PRESTADA_A_MAE_POR_LESAO_FETAL_SUSPEITADA_CAUSADA_POR_DROGAS: 6615,
ASSISTENCIA_PRESTADA_A_MAE_POR_LESAO_FETAL_SUSPEITADA_CAUSADA_POR_OUTROS_PROCEDIMENTOS_MEDICOS: 6617,
ASSISTENCIA_PRESTADA_A_MAE_POR_LESAO_FETAL_SUSPEITADA_CAUSADA_POR_RADIACAO: 6616,
ASSISTENCIA_PRESTADA_A_MAE_POR_LESAO_OU_ANORMALIDADE_FETAIS_SUSPEITADAS_NAO_ESPECIFICADAS: 6619,
ASSISTENCIA_PRESTADA_A_MAE_POR_MALFORMACAO_DO_SISTEMA_NERVOSO_CENTRAL_DO_FETO_SUSPEITADA: 6610,
ASSISTENCIA_PRESTADA_A_MAE_POR_OUTRAS_ANORMALIDADES_DO_COLO_DO_UTERO: 6603,
ASSISTENCIA_PRESTADA_A_MAE_POR_OUTRAS_ANORMALIDADES_DO_UTERO_GRAVIDICO: 6604,
ASSISTENCIA_PRESTADA_A_MAE_POR_OUTRAS_ANORMALIDADES_DOS_ORGAOS_PELVICOS: 6607,
ASSISTENCIA_PRESTADA_A_MAE_POR_OUTRAS_ANORMALIDADES_OU_LESOES_FETAIS_SUSPEITADAS: 6618,
ASSISTENCIA_PRESTADA_A_MAE_POR_OUTRAS_FORMAS_DE_APRESENTACAO_ANORMAL_DO_FETO: 6585,
ASSISTENCIA_PRESTADA_A_MAE_POR_OUTROS_PROBLEMAS_FETAIS_ESPECIFICADOS: 6629,
ASSISTENCIA_PRESTADA_A_MAE_POR_OUTROS_TIPOS_DE_ISOIMUNIZACAO: 6622,
ASSISTENCIA_PRESTADA_A_MAE_POR_POLO_CEFALICO_ALTO_EM_GESTACAO_A_TERMO: 6582,
ASSISTENCIA_PRESTADA_A_MAE_POR_POSICAO_FETAL_INSTAVEL: 6578,
ASSISTENCIA_PRESTADA_A_MAE_POR_POSICAO_FETAL_TRANSVERSA_E_OBLIQUA: 6580,
ASSISTENCIA_PRESTADA_A_MAE_POR_PROBLEMA_FETAL_NAO_ESPECIFICADO: 6630,
ASSISTENCIA_PRESTADA_A_MAE_POR_SINAIS_DE_HIPOXIA_FETAL: 6624,
ASSISTENCIA_PRESTADA_A_MAE_POR_TUMOR_DO_CORPO_DO_UTERO: 6600,
ASSISTENCIA_PRESTADA_A_MAE_POR_UMA_DESPROPORCAO_DE_ORIGEM_MISTA_MATERNA_E_FETAL: 6592,
ASSISTENCIA_PRESTADA_A_MAE_POR_UMA_DESPROPORCAO_DE_OUTRA_ORIGEM: 6596,
ASSISTENCIA_PRESTADA_A_MAE_POR_UMA_DESPROPORCAO_DEVIDA_A_FETO_EXCEPCIONALMENTE_GRANDE: 6593,
ASSISTENCIA_PRESTADA_A_MAE_POR_UMA_DESPROPORCAO_DEVIDA_A_FETO_HIDROCEFALICO: 6594,
ASSISTENCIA_PRESTADA_A_MAE_POR_UMA_DESPROPORCAO_DEVIDA_A_OUTRAS_DEFORMIDADES_FETAIS: 6595,
ASSISTENCIA_PRESTADA_A_MAE_POR_UMA_DESPROPORCAO_DEVIDA_A_CONTRACAO_DO_ESTREITO_INFERIOR_DA_PELVE: 6591,
ASSISTENCIA_PRESTADA_A_MAE_POR_UMA_DESPROPORCAO_DEVIDA_A_CONTRACAO_DO_ESTREITO_SUPERIOR_DA_PELVE: 6590,
ASSISTENCIA_PRESTADA_A_MAE_POR_UMA_DESPROPORCAO_DEVIDA_A_CONTRACAO_GERAL_DA_PELVE: 6589,
ASSISTENCIA_PRESTADA_A_MAE_POR_UMA_DESPROPORCAO_DEVIDA_A_DEFORMIDADE_DA_PELVE_OSSEA_MATERNA: 6588,
ASSISTENCIA_PRESTADA_A_MAE_POR_UMA_DESPROPORCAO_NAO_ESPECIFICADA: 6597,
ASSISTENCIA_A_MAE_POR_MALFORMACAO_CONGENITA_DO_UTERO: 6599,
CEFALEIA_CAUSADA_POR_ANESTESIA_RAQUIDIANA_OU_PERIDURAL_ADMINISTRADAS_DURANTE_A_GRAVIDEZ: 6561,
COMPLICACOES_CARDIACAS_DE_ANESTESIA_ADMINISTRADA_DURANTE_A_GRAVIDEZ: 6558,
COMPLICACOES_DE_ANESTESIA_ADMINISTRADA_DURANTE_A_GRAVIDEZ: 6556,
COMPLICACOES_DE_ANESTESIA_DURANTE_A_GRAVIDEZ_NAO_ESPECIFICADAS: 6565,
COMPLICACOES_ESPECIFICAS_DE_GESTACAO_MULTIPLA: 6572,
COMPLICACOES_PULMONARES_DE_ANESTESIA_ADMINISTRADA_DURANTE_A_GRAVIDEZ: 6557,
COMPLICACOES_RELATIVAS_AO_SISTEMA_NERVOSO_CENTRAL_DEVIDA_A_ANESTESIA_ADMINISTRADA_DURANTE_A_GRAVIDEZ: 6559,
COMPLICACOES_VENOSAS_NA_GRAVIDEZ: 6511,
COMPLICACOES_VENOSAS_NA_GRAVIDEZ_NAO_ESPECIFICADAS: 6519,
CONTINUACAO_DA_GRAVIDEZ_APOS_A_MORTE_INTRA_UTERINA_DE_UM_OU_MAIS_FETOS: 6575,
CONTINUACAO_DA_GRAVIDEZ_APOS_ABORTO_DE_UM_OU_MAIS_FETOS: 6574,
DESNUTRICAO_NA_GRAVIDEZ: 6535,
DIABETES_MELLITUS_NA_GRAVIDEZ: 6528,
DIABETES_MELLITUS_NA_GRAVIDEZ_NAO_ESPECIFICADO: 6534,
DIABETES_MELLITUS_PRE_EXISTENTE_INSULINO_DEPENDENTE: 6529,
DIABETES_MELLITUS_PRE_EXISTENTE_NAO_ESPECIFICADO: 6532,
DIABETES_MELLITUS_PRE_EXISTENTE_NAO_INSULINO_DEPENDENTE: 6530,
DIABETES_MELLITUS_PRE_EXISTENTE_RELACIONADO_COM_A_DESNUTRICAO: 6531,
DIABETES_MELLITUS_QUE_SURGE_DURANTE_A_GRAVIDEZ: 6533,
DISTURBIO_HIPERTENSIVO_PRE_EXISTENTE_COM_PROTEINURIA_SUPERPOSTA: 6485,
DOENCA_INFECCIOSA_PARASITARIA_MATERNA_COP_MAS_QUE_COMPLIQUEM_A_GRAVIDEZ_O_PARTO_E_O_PUERPERIO: 6867,
DOENCAS_DA_PELE_E_DO_TECIDO_SUBCUTANEO_COMPLICANDO_A_GRAVIDEZ_O_PARTO_E_O_PUERPERIO: 6885,
DOENCAS_DO_APARELHO_CIRCULATORIO_COMPLICANDO_A_GRAVIDEZ_O_PARTO_E_O_PUERPERIO: 6882,
DOENCAS_DO_APARELHO_DIGESTIVO_COMPLICANDO_A_GRAVIDEZ_O_PARTO_E_O_PUERPERIO: 6884,
DOENCAS_DO_APARELHO_RESPIRATORIO_COMPLICANDO_A_GRAVIDEZ_O_PARTO_E_O_PUERPERIO: 6883,
DOENCAS_ENDOCRINAS_NUTRICIONAIS_E_METABOLICAS_COMPLICANDO_A_GRAVIDEZ_O_PARTO_E_O_PUERPERIO: 6880,
ECLAMPSIA: 6495,
ECLAMPSIA_NA_GRAVIDEZ: 6496,
ECLAMPSIA_NO_TRABALHO_DE_PARTO: 6497,
ECLAMPSIA_NAO_ESPECIFICADA_QUANTO_AO_PERIODO: 6499,
EDEMA_E_PROTEINURIA_GESTACIONAIS_INDUZIDOS_PELA_GRAVIDEZ_SEM_HIPERTENSAO: 6486,
EDEMA_GESTACIONAL: 6487,
EDEMA_GESTACIONAL_COM_PROTEINURIA: 6489,
FALHA_OU_DIFICULDADE_NA_ENTUBACAO_DURANTE_A_GRAVIDEZ: 6563,
FALSO_TRABALHO_DE_PARTO: 6658,
FALSO_TRABALHO_DE_PARTO_ANTES_DE_SE_COMPLETAREM_37_SEMANAS_DE_GESTACAO: 6659,
FALSO_TRABALHO_DE_PARTO_NA_37ª_SEMANA_COMPLETA_OU_DEPOIS_DELA: 6660,
FALSO_TRABALHO_DE_PARTO_NAO_ESPECIFICADO: 6661,
FEBRE_DURANTE_O_TRABALHO_DE_PARTO_NAO_CLASSIFICADA_EM_OUTRA_PARTE: 6770,
FLEBOTROMBOSE_PROFUNDA_NA_GRAVIDEZ: 6515,
GANHO_DE_PESO_INSUFICIENTE_NA_GRAVIDEZ: 6538,
GANHO_EXCESSIVO_DE_PESO_NA_GRAVIDEZ: 6537,
GESTACAO_MULTIPLA: 6566,
GESTACAO_MULTIPLA_NAO_ESPECIFICADA: 6571,
GRAVIDEZ_COMO_ACHADO_CASUAL: 13718,
GRAVIDEZ_CONFIRMADA: 13717,
GRAVIDEZ_DUPLA: 6567,
GRAVIDEZ_ECTOPICA: 6397,
GRAVIDEZ_ECTOPICA_NAO_ESPECIFICADA: 6402,
GRAVIDEZ_PROLONGADA: 6662,
GRAVIDEZ_QUADRIGEMELAR: 6569,
GRAVIDEZ_TRIGEMELAR: 6568,
HEMORRAGIA_ANTEPARTO_COM_DEFICIENCIA_DE_COAGULACAO: 6655,
HEMORRAGIA_ANTEPARTO_NAO_CLASSIFICADA_EM_OUTRA_PARTE: 6654,
HEMORRAGIA_ANTEPARTO_NAO_ESPECIFICADA: 6657,
HEMORRAGIA_DO_INICIO_DA_GRAVIDEZ: 6501,
HEMORRAGIA_DO_INICIO_DA_GRAVIDEZ_NAO_ESPECIFICADA: 6504,
HEMORROIDAS_NA_GRAVIDEZ: 6516,
HERPES_GESTACIONAL: 6541,
HIPERTENSAO_GESTACIONAL_INDUZIDA_PELA_GRAVIDEZ_SEM_PROTEINURIA_SIGNIFICATIVA: 6490,
HIPERTENSAO_MATERNA_NAO_ESPECIFICADA: 6500,
HIPERTENSAO_GESTACIONAL_INDUZIDA_PELA_GRAVIDEZ_COM_PROTEINURIA_SIGNIFICATIVA: 6491,
HIPERTENSAO_PRE_EXISTENTE_COMPLICANDO_A_GRAVIDEZ_O_PARTO_E_O_PUERPERIO: 6478,
HIPEREMESE_GRAVIDICA_COM_DISTURBIO_METABOLICO: 6507,
HIPEREMESE_GRAVIDICA_LEVE: 6506,
INFECCAO_DO_SACO_AMNIOTICO_E_DAS_MEMBRANAS: 6634,
INFECCAO_NAO_ESPECIFICADA_DO_TRATO_URINARIO_NA_GRAVIDEZ: 6525,
INFECCOES_DA_BEXIGA_NA_GRAVIDEZ: 6522,
INFECCOES_DA_URETRA_NA_GRAVIDEZ: 6523,
INFECCOES_DE_OUTRAS_PARTES_DO_TRATO_URINARIO_NA_GRAVIDEZ: 6524,
INFECCOES_DO_RIM_NA_GRAVIDEZ: 6521,
INFECCOES_DO_TRATO_GENITAL_NA_GRAVIDEZ: 6526,
INFECCOES_DO_TRATO_GENITURINARIO_NA_GRAVIDEZ: 6520,
MALFORMACAO_DA_PLACENTA: 6644,
OLIGOHIDRAMNIO: 6633,
OUTRA_FORMA_DE_HEMORRAGIA_ANTEPARTO: 6656,
OUTRAS_AFECCOES_ESPECIFICADAS_LIGADAS_A_GRAVIDEZ: 6545,
OUTRAS_COMPLICACOES_DE_ANESTESIA_DURANTE_A_GRAVIDEZ: 6564,
OUTRAS_COMPLICACOES_DE_ANESTESIA_RAQUIDIANA_OU_PERIDURAL_ADMINISTRADAS_DURANTE_A_GRAVIDEZ: 6562,
OUTRAS_COMPLICACOES_ESPECIFICAS_DE_GESTACAO_MULTIPLA: 6576,
OUTRAS_COMPLICACOES_LIGADAS_PREDOMINANTEMENTE_A_GRAVIDEZ: 6536,
OUTRAS_COMPLICACOES_VENOSAS_NA_GRAVIDEZ: 6518,
OUTRAS_DOENCAS_DO_SANGUE_E_DOS_ORGAOS_HEMATOP_E_ALGUNS_TRANST_QUE_COMPROMETEM_O_SIST_IMUNOLOGICO: 6879,
OUTRAS_FORMAS_DE_VOMITOS_COMPLICANDO_A_GRAVIDEZ: 6509,
OUTRAS_GESTACOES_MULTIPLAS: 6570,
OUTRAS_HEMORRAGIAS_DO_INICIO_DA_GRAVIDEZ: 6503,
OUTRAS_INFECCOES_DURANTE_O_TRABALHO_DE_PARTO: 6771,
OUTRAS_INFECCOES_E_AS_NAO_ESPECIFICADAS_DO_TRATO_URINARIO_NA_GRAVIDEZ: 6527,
OUTROS_ACHADOS_ANORMAIS_DO_RASTREAMENTO_SCREENING_ANTENATAL_DA_MAE: 6554,
OUTROS_TRANSTORNOS_DA_PLACENTA: 6645,
OUTROS_TRANSTORNOS_ESPECIFICADOS_DO_LIQUIDO_AMNIOTICO_E_DAS_MEMBRANAS: 6635,
PLACENTA_PREVIA: 6647,
PLACENTA_PREVIA_COM_HEMORRAGIA: 6649,
PLACENTA_PREVIA_ESPECIFICADA_COMO_SEM_HEMORRAGIA: 6648,
POLI_HIDRAMNIO: 6631,
PROBLEMAS_RELACIONADOS_COM_UMA_GRAVIDEZ_NAO_DESEJADA: 13973,
PROTEINURIA_GESTACIONAL: 6488,
PRE_ECLAMPSIA_GRAVE: 6493,
PRE_ECLAMPSIA_MODERADA: 6492,
PRE_ECLAMPSIA_NAO_ESPECIFICADA: 6494,
RASTREAMENTO_SCREENING_PRE_NATAL: 13734,
REACAO_TOXICA_CAUSADA_POR_ANESTESIA_LOCAL_ADMINISTRADA_DURANTE_A_GRAVIDEZ: 6560,
RETENCAO_DE_DISPOSITIVO_INTRA_UTERINO_CONTRACEPTIVO_DIU_NA_GRAVIDEZ: 6540,
SUPERVISAO_DE_GRAVIDEZ_COM_GRANDE_MULTIPARIDADE: 13728,
SUPERVISAO_DE_GRAVIDEZ_COM_HISTORIA_DE_ABORTO: 13725,
SUPERVISAO_DE_GRAVIDEZ_COM_HISTORIA_DE_ASSISTENCIA_PRE_NATAL_INSUFICIENTE: 13727,
SUPERVISAO_DE_GRAVIDEZ_COM_HISTORIA_DE_ESTERILIDADE: 13724,
SUPERVISAO_DE_GRAVIDEZ_COM_OUTROS_ANTECEDENTES_DE_PROCRIACAO_PROBLEMATICA: 13726,
SUPERVISAO_DE_GRAVIDEZ_DE_ALTO_RISCO: 13723,
SUPERVISAO_DE_GRAVIDEZ_DE_ALTO_RISCO_DEVIDO_A_PROBLEMAS_SOCIAIS: 13731,
SUPERVISAO_DE_GRAVIDEZ_NORMAL: 13719,
SUPERVISAO_DE_GRAVIDEZ_NORMAL_NAO_ESPECIFICADA: 13722,
SUPERVISAO_DE_OUTRA_GRAVIDEZ_NORMAL: 13721,
SUPERVISAO_DE_OUTRAS_GRAVIDEZES_DE_ALTO_RISCO: 13732,
SUPERVISAO_DE_PRIMEIRA_GRAVIDEZ_NORMAL: 13720,
SUPERVISAO_NAO_ESPECIFICADA_DE_GRAVIDEZ_DE_ALTO_RISCO: 13733,
SINDROME_DA_HIPOTENSAO_MATERNA: 6542,
SINDROMES_DE_TRANSFUSAO_PLACENTARIA: 6643,
TRANSTORNO_DA_PLACENTA_NAO_ESPECIFICADO: 6646,
TRANSTORNOS_DA_PLACENTA: 6642,
TRANSTORNOS_DAS_MEMBRANAS_E_DO_LIQUIDO_AMNIOTICO: 6632,
TRANSTORNOS_DO_LIQUIDO_AMNIOTICO_E_DAS_MEMBRANAS_NAO_ESPECIFICADOS: 6636,
TRANSTORNOS_MENTAIS_E_DOENCAS_DO_SISTEMA_NERVOSO_COMPLICANDO_A_GRAVIDEZ_O_PARTO_E_O_PUERPERIO: 6881,
TROMBOFLEBITE_SUPERFICIAL_NA_GRAVIDEZ: 6514,
TROMBOSE_VENOSA_CEREBRAL_NA_GRAVIDEZ: 6517,
VARIZES_DOS_MEMBROS_INFERIORES_NA_GRAVIDEZ: 6512,
VARIZES_GENITAIS_NA_GRAVIDEZ: 6513,
VOMITOS_EXCESSIVOS_NA_GRAVIDEZ: 6505,
VOMITOS_DA_GRAVIDEZ_NAO_ESPECIFICADOS: 6510,
}

